/**
 * Maps product SKU to its primary imageKey.
 * Used by frontend image resolvers to look up StaticImageData.
 */
export const SKU_IMAGE_KEYS: Record<string, string> = {
  'bok-messis-dagbok': 'messis-dagbok-cover',
  'bok-lana-eller-lina': 'lana-eller-lina-cover',
};
